import React from 'react';
import { Lightbulb } from 'lucide-react';

const FundingReadinessRecommendations = ({ recommendations = [] }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] p-4">
    <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-[var(--fg-text)]">
      <Lightbulb className="size-4 text-[var(--fg-accent)]" />
      Recommendations
    </div>
    {recommendations.length === 0 ? (
      <p className="text-sm text-[var(--fg-muted)]">Recommendations will appear after readiness is calculated.</p>
    ) : (
      <ul className="space-y-2">
        {recommendations.map((item) => (
          <li key={item} className="rounded-lg border border-[var(--fg-line)] bg-white px-3 py-2 text-sm text-[var(--fg-text)] dark:bg-[rgba(11,31,24,0.65)]">
            {item}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default FundingReadinessRecommendations;
